import React, { useState } from 'react';
import styles from './Avatar.module.sass';

const Tooltip = React.lazy(() => import('../Tooltip/Tooltip'));

const Avatar = ({
    src,
    children
}: Props) => {
    const [tooltipRef, setTooltipRef] = useState<any>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleTooltipHover = (value: boolean) => () => setShowTooltip(value);

    return <>
        <img
            src={src}
            loading='lazy'
            alt={children}
            className={styles['avatar']}
            ref={setTooltipRef}
            onMouseEnter={handleTooltipHover(true)}
            onMouseLeave={handleTooltipHover(false)}
        />
        {
            showTooltip &&
            <Tooltip ref={tooltipRef}>
                { children }
            </Tooltip>
        }
    </>;
}

interface Props {
    src: any
    children: any
}

export default Avatar;